import type { ObjectType } from '@quromedical/fhir-common';
import * as yup from 'yup';

import type { PathologyOrderCreateRequest } from './schema';

export const createPathologyOrderSchema = yup
  .object<ObjectType<PathologyOrderCreateRequest>>({
    comment: yup.string().optional(),
    sampleDateTime: yup.date().required(),
    testCodes: yup.array(yup.string().required()).required().min(1),
    copyDoctors: yup.array(yup.string().notRequired()).optional(),
  })
  .required();
